module.exports = __webpack_public_path__ + "img/chain_ast.d12b0790.svg";